import React, { useState, useEffect } from "react"
import Modal from "./index"
import Button from "../Form/Button"
import FormGroup from "../Form/FormGroup"
import Input from "../Form/Input"
import Select from "../Form/Select"
import FormGroupInline from "../Form/FormGroupInline"
import BreakForm from "../Form/BreakForm"
import { FaPencilAlt } from "react-icons/fa"
import { MdOutlineWhatsapp } from "react-icons/md"
import { getOptionByOptionList } from "../../utils/utils"

const ModalWhatsAppInstance = ({ isNew, value = {}, editable, canEdit = true, setEdit, onSubmit, closeModal }) => {
    const [instance, setInstance] = useState(value)

    useEffect(() => {
        setInstance(value)
    }, [value])

    const optionsMode = [
        { id: "shared", value: "Compartilhado" },
        { id: "exclusive", value: "Exclusivo" },
        { id: "restricted", value: "Restrito" }
    ]

    const optionsStatus = [
        { id: 1, value: "Ativa" },
        { id: 0, value: "Inativa" }
    ]

    const handleChange = (name, value) => {
        setInstance(prev => ({ ...prev, [name]: value }))
    }

    const handleCancel = (e) => {
        e.preventDefault()
        if (isNew) return closeModal()
        setEdit(false)
        setInstance(value)
    }

    return (
        <Modal
            icon={<MdOutlineWhatsapp />}
            title={isNew ? "Cadastro de nova instância" : (editable ? `Editando: ${instance.name}` : `Visualizando: ${instance.name}`)}
            description={isNew ? "Adicione uma nova instância" : (editable ? "Altere as informações abaixo e clique no botão salvar" : (canEdit ? `Caso queira editar as informações clique no ícone de edição` : "Você tem acesso somente para visualização"))}
            closeModal={closeModal}
        >
            <form onSubmit={(e) => onSubmit(e, isNew, instance)}>
                <FormGroupInline>
                    <FormGroup labelText="Nome">
                        {editable
                            ? <Input value={instance?.name || ""} placeholder="Nome da Instância" onChange={e => handleChange("name", e.target.value)} />
                            : <span>{instance?.name || "-"}</span>
                        }
                    </FormGroup>
                    {!editable && canEdit && (
                        <Button variant="secondary" className="action" onClick={() => setEdit(true)}>
                            <FaPencilAlt />
                        </Button>
                    )}
                </FormGroupInline>
                <FormGroup labelText="URL">
                    {editable
                        ? <Input value={instance?.address || ""} placeholder="URL da Instância" onChange={e => handleChange("address", e.target.value)} />
                        : <span>{instance?.address || "-"}</span>
                    }
                </FormGroup>
                <FormGroup labelText="API Key">
                    {editable
                        ? <Input value={instance?.api_key || ""} placeholder="Chave de API da Instância" onChange={e => handleChange("api_key", e.target.value)} />
                        : <span>{instance?.api_key || "-"}</span>
                    }
                </FormGroup>
                <BreakForm title="Configuração" showAction={false} />
                <FormGroup labelText="Modo">
                    {editable
                        ? <Select
                            name="Modo"
                            placeholder="Digite para pesquisar..."
                            options={optionsMode}
                            selected={instance?.mode}
                            onChange={(v) => handleChange("mode", v)}
                            multiple={false}
                        />
                        : <span>{getOptionByOptionList(instance?.mode, optionsMode) || "-"}</span>
                    }
                </FormGroup>
                {(instance?.mode === "exclusive" || instance?.mode === "restricted") && (
                    <FormGroup labelText="Contas (IDs)">
                        {editable
                            ? <Input
                                placeholder="Separe por vírgula"
                                value={instance?.account_ids?.join(",") || ""}
                                onChange={(e) =>
                                    handleChange("account_ids", e.target.value.split(","))
                                }
                            />
                            : <span>{instance?.account_ids?.join(", ") || "-"}</span>
                        }
                    </FormGroup>
                )}

                <BreakForm title="Capacidade" showAction={false} />
                <FormGroupInline>
                    <FormGroup labelText="Máx. Inbox">
                        {editable
                            ? <Input
                                type="number"
                                value={instance?.max_inboxes || ""}
                                placeholder="Máx. Inbox"
                                onChange={(e) => handleChange("max_inboxes", e.target.value)}
                            />
                            : <span>{instance?.max_inboxes || "-"}</span>
                        }
                    </FormGroup>
                    <FormGroup labelText="Prioridade">
                        {editable
                            ? <Input
                                type="number"
                                value={instance?.priority || ""}
                                placeholder="Prioridade da Instância"
                                onChange={(e) => handleChange("priority", e.target.value)}
                            />
                            : <span>{instance?.priority || "-"}</span>
                        }
                    </FormGroup>
                </FormGroupInline>
                <FormGroup labelText="Status">
                    {editable
                        ? <Select
                            name="Status"
                            placeholder="Digite para pesquisar..."
                            options={optionsStatus}
                            selected={+instance?.is_active}
                            onChange={(v) => handleChange("is_active", v)}
                            multiple={false}
                        />
                        : <span>{getOptionByOptionList(+instance?.is_active, optionsStatus) || "-"}</span>
                    }
                </FormGroup>

                {editable && (
                    <FormGroupInline>
                        <Button variant="primary" type="submit">Salvar</Button>
                        <Button variant="secondary" onClick={handleCancel}>Cancelar</Button>
                    </FormGroupInline>
                )}
            </form>
        </Modal>
    )
}

export default ModalWhatsAppInstance
